"use strict";

define('rs/form/attachment.controller',['rs/form/abstract.form.entity', 'rs/form/attachment.view', 'rs/form/attachment.document', 'rs/helper'], function (AbstractFormEntity, AttachmentView, AttachmentDocument, helper) {
  var AttachmentController = AbstractFormEntity.extend({
    properties: ['attach', 'hasMultiple', 'samples', 'value'],
    propertiesDefinitions: ['name', 'hasMultiple', 'text', 'samples', 'uploadButton'],
    linksDefinitions: [],
    samples: null,
    attach: true,
    isAttachment: true,
    isAnswerable: true,
    canBeLinkedFromFormObject: function canBeLinkedFromFormObject(linker, type) {
      if (type == "attach") {
        return true;
      }
      return false;
    },
    initialize: function initialize() {
      this.samples = [];
      this._super.apply(this, arguments);
      var samples = this.getSamples();
      for (var i = 0, len = samples.length; i < len; i++) {
        samples[i] = new AttachmentDocument(samples[i]);
      }
      this.startListeners();
    },
    addSample: function addSample(sample) {
      var samples = this.getSamples() || [];
      samples.push(new AttachmentDocument(sample));
      this.setSamples(samples, {
        silent: true
      });
      this.trigger('change:samples');
    },
    addDocument: function addDocument(attachmentDocument, options) {
      var values = this.getValue() || [];
      values.push(new AttachmentDocument(attachmentDocument));
      this.setValue(values, {
        silent: true
      });
      if (!options || !options.silent) {
        this.trigger('change:value');
      }
    },
    processDocuments: function processDocuments() {
      var data = this.getFormController().getFormObjectDataByID(this.getId());
      if (data && helper.isJSON(data)) {
        data = JSON.parse(data);
        for (var i = 0, len = data.length; i < len; i++) {
          data[i] = new AttachmentDocument(data[i]);
        }
      }
      this.setValue(data || []);
    },
    removeDocumentAtIndex: function removeDocumentAtIndex(index) {
      var value = this.getValue();
      value.splice(index, 1);
      this.trigger('change:value');
    },
    removeSampleAtIndex: function removeSampleAtIndex(index) {
      var samples = this.getSamples();
      samples.splice(index, 1);
      this.trigger('change:samples');
    },
    removeItemFromPropertyList: function removeItemFromPropertyList(propertyName, index) {
      if (propertyName == "samples") {
        this.removeSampleAtIndex(index);
      } else {
        this._super.apply(this, arguments);
      }
    },
    setupView: function setupView() {
      this.setView(new AttachmentView());
    },
    setValue: function setValue(value, silent) {
      this._super.apply(this, arguments);
    },
    startListeners: function startListeners() {
      this.listenTo(this, 'change:attach', this.attachDidChange);
      this.listenTo(this, 'change:samples', this.samplesDidChange);
      this.listenTo(this, 'change:value', this.valueDidChange);
    },
    attachDidChange: function attachDidChange() {
      var view = this.getView();
      if (this.getAttach()) {
        view.show();
      } else {
        view.hide();
      }
    },
    valueDidChange: function valueDidChange() {
      var buttonsAttached = this.getLinkedAttachButtons();
      this.getFormController().attachmentDidChange();
      for (var i = 0, len = buttonsAttached.length; i < len; i++) {
        var validTarget = buttonsAttached[i].target;
        if (_.isFunction(validTarget.refreshAttachments)) {
          buttonsAttached[i].target.refreshAttachments();
        }
      }
    },
    getLinkedAttachButtons: function getLinkedAttachButtons() {
      return _.filter(this.getDependencies(), function (d) {
        return d.type == "attach";
      });
    },
    getSectionController: function getSectionController() {
      return null;
    },
    samplesDidChange: function samplesDidChange() {
      var buttonsAttached = this.getLinkedAttachButtons();
      for (var i = 0, len = buttonsAttached.length; i < len; i++) {
        buttonsAttached[i].target.getView().refresh();
      }
      this.getFormController().setUnsavedChanges(true);
    },
    addNewDependent: function addNewDependent(property, formObject) {
      if (property == "attached") {
        console.error("HEY! remove existing attached dependencies");
      }
      return this._super.apply(this, arguments);
    },
    requestSampleUpload: function requestSampleUpload() {
      var formController = this.getFormController(),
        samples = formController.requestAttachmentsUpload('UPLOAD SAMPLES', [], true);
      samples.bind(this).spread(function (files, links) {
        _.each(files.concat(links), this.addSample, this);
        formController.triggerRefreshPropertiesTab();
      });
    },
    requestDocumentUpload: function requestDocumentUpload(modalOptions) {
      var formController = this.getFormController(),
        multiple = this.getHasMultiple(),
        samples = formController.requestAttachmentsUpload('DOCUMENTS', this.getValue(), multiple, modalOptions);
      samples.bind(this).spread(function (files, links) {
        this.setValue([], {
          silent: true
        });
        var attachments = files.concat(links);
        if (multiple) {
          for (var i = 0, len = attachments.length; i < len; i++) {
            this.addDocument(attachments[i], {
              silent: true
            });
          }
          this.trigger('change:value');
        } else {
          var attachment = attachments[0];
          if (attachment) {
            this.addDocument(attachment);
          } else {
            this.trigger('change:value');
          }
        }
      });
    },
    requestDocumentView: function requestDocumentView() {},
    removeFromParent: function removeFromParent() {
      var parent = this.getParent(),
        attachments = parent.getAttachments(),
        index = attachments.indexOf(this);
      attachments.splice(index, 1);
    },
    toJSON: function toJSON() {
      var json = this._super.apply(this, arguments);
      json.samples = _.map(this.getSamples(), function (sample) {
        return sample.toJSON();
      });
      json.hasMultiple = this.getHasMultiple();
      return json;
    }
  }, {
    getTypeString: function getTypeString() {
      return 'Attachment';
    },
    propertiesDefinitions: _.extend({}, AbstractFormEntity.propertiesDefinitions, {
      'text': {
        name: 'text',
        text: true,
        displayName: 'Title'
      },
      'hasMultiple': {
        name: 'hasMultiple',
        bool: true,
        displayName: 'Allow Multiple'
      },
      'samples': {
        name: 'samples',
        list: true,
        deletable: true,
        displayName: 'Samples'
      },
      'uploadButton': {
        name: 'uploadButton',
        button: true,
        handler: 'requestSampleUpload',
        displayName: 'Upload Samples'
      }
    })
  });
  return AttachmentController;
});

